import { _ as a } from "./index742.mjs";
import { n as e } from "./index759.mjs";
var t = a, r = e;
t({ global: !0, forced: parseInt !== r }, {
  parseInt: r
});
